import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../hooks/useSelector";
import { ROLES } from "../../constants/textconstants";
import { usePermissions } from "../../hooks/usePermissions";
import { FEATURES } from "../../config/permissions";

const Tabs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useAppSelector((state: any) => state.formConfig.user);

  const { can } = usePermissions();
  const isMhLicenseManager =
    userData?.role === ROLES.LICENSE_MANAGER && !!userData?.show_govt_approval_tab;

  const allTabs = [
    { name: "Overview", path: "/", feature: FEATURES.TAB_OVERVIEW },
    { name: "Certificate Requests", path: "/all-requests/0", feature: FEATURES.TAB_CERTIFICATE_REQUESTS },
    { name: "Issued Certificates", path: "/issued-certificates", feature: FEATURES.TAB_ISSUED_CERTIFICATES },
    { name: "Assigned Booklets", path: "/assigned-certificates", feature: FEATURES.TAB_ASSIGNED_BOOKLETS },
  ];

  const tabs = allTabs.filter((tab) => {
    // For Mahaparwana License Manager flow, replace Issued Certificates with Certificate Requests.
    if (isMhLicenseManager && tab.name === "Issued Certificates") {
      return false;
    }
    if (isMhLicenseManager && tab.name === "Certificate Requests") {
      return true;
    }
    return can(tab.feature);
  });

  

  return (
    <div className="tabs">
      {tabs.map((tab) => {
        let isActive = false;
        if (tab.name === "Certificate Requests") {
          isActive = location.pathname.startsWith("/all-requests") || location.pathname.startsWith("/review-request");
        } else if (tab.name === "Issued Certificates") {
          isActive = location.pathname.startsWith("/issued-certificates") || location.pathname.startsWith("/review-request");
        } else if (tab.name === "Assigned Booklets") {
          isActive = location.pathname.startsWith("/assigned-certificates");
        }
        else {
          isActive = location.pathname === tab.path;
        }

        let activeclass = isActive ? "active" : "";
        return(
        <span
          key={tab.name}
          className={tab.name === 'Overview' ? `certificate-overview-container ${activeclass}`:
          tab.name =='Issued Certificates'? `issued-certificate-container ${activeclass}`:
          tab.name == 'Assigned Booklets'? `assigned-booklets-container ${activeclass}`:  activeclass}
          onClick={() => navigate(tab.path)}
        >
          {tab.name}
        </span>
      )
      }
    )}
    </div>
  );
};

export default Tabs;
